import Vue from 'vue'
import Noty from 'noty'

const defaults = {
  theme: 'rl',
  timeout: 3000
}

Vue.prototype.$noty = ( options ) => new Noty( Object.assign( {}, defaults, options ) ).show()
